import { render, staticRenderFns } from "./A4_1x3.vue?vue&type=template&id=54b99796&scoped=true&"
import script from "./A4_1x3.vue?vue&type=script&lang=js&"
export * from "./A4_1x3.vue?vue&type=script&lang=js&"
import style0 from "./A4_1x3.vue?vue&type=style&index=0&id=54b99796&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b99796",
  null
  
)

export default component.exports